import { Query } from '@apollo/client/react/components';
import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { WorkbookQuery, WorkbookQueryVariables, WorkbookDocument } from '../../../../../gen-src/queries';
import {
  CenteredFadeInSpinner,
  CenteredMessage,
} from '../../../data-catalog-shared';
import { RenderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

export type WorkbookQueryWorkbooks = Unpacked<WorkbookQuery['workbooks']>

export type WorkbookQueryWrapperProps = {
  readonly vizportalUrlId: string;
  readonly children: (result: WorkbookQueryWorkbooks) => React.ReactNode;
};

export class WorkbookQueryWrapper extends React.Component<WorkbookQueryWrapperProps> {

  public override render(): React.ReactNode {
    return (
      <Query<WorkbookQuery, WorkbookQueryVariables>
        query={WorkbookDocument}
        variables={{ workbookVizportalUrlId: this.props.vizportalUrlId }}
      >
        {result =>
          <RenderQueryResult result={result} renderers={{
            renderLoading: () => <CenteredFadeInSpinner />,
            renderData: this.renderWorkbookData,
            renderNoData: renderNoData,
            renderDataWithError: createRenderDataWithErrorFunction(this.renderWorkbookData),
            renderError: renderError,
          }} />
        }
      </Query>
    );
  }

  private readonly renderWorkbookData = (data: WorkbookQuery): React.ReactNode => {
    const workbook = data.workbooks ? data.workbooks[0] : null;
    if (workbook) {
      return this.props.children(workbook);
    } else {
      return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
    }
  }

}
